<template>
    <transition name="fade">
            <!-- Modal -->
        <div v-if="show" class="modal" tabindex="-1">
            <div ref="modal" class="modal-dialog" v-dragme v-on-clickaway="close">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close"  aria-label="Close"  @click="close"
                                ><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title">{{ title }}</h4>
                    </div>
                    <div class="modal-body" v-html="body" @mousedown.prevent="stopDrag"></div>
                    <div class="modal-footer" v-if="showFooter">
                        <button type="button" class="btn btn-default" @click="close">{{ getTranslation('btn_ok') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>


<script>
    import { mixin as clickaway } from 'vue-clickaway';
    import { translationMixin } from '../mixins/translationMixin';
    import { dragme } from '../directives/dragme';

    export default {
        props: ['show', 'title', 'body', 'showFooter'],
        mixins:[ clickaway, translationMixin ],
        data: function(){
            return {
                toShow: this.show
            }
        },
        directives: {dragme: dragme},
//        computed: {
//            display: function(){
//                console.log('toShow', this.show);
//                if(this.show){
//                    this.toDisplay = 'display:block'
//                } else {
//                    this.toDisplay = 'display:none'
//                }
//                return this.toDisplay;
//            }
//        },
        methods: {
            close: function(){
                this.$emit('infoClose');
            },
           stopDrag: function(){
              return false;
           }
        }
    }
</script>

<style scoped>
    .modal-header {
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// BanetModalInfo.vue?6b110eb6